export type { INumberInputProps } from './NumberInput'
export { NumberInput } from './NumberInput'
